<template>
  <div class="app-device-configurator">
    <slot name ="txtBefore"></slot>
    <a :href="targetUrl" target="_blank"><slot name="linkText">Link mit dem Text</slot></a>
    <slot name ="txtAfter"></slot>
  </div>
</template>

<script>

import gql from 'graphql-tag'
import { wrapQuery } from '../../../../helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'

export default {
  name: 'DeviceConfigurator',
  props: {
    baseUrl: {
      type: String,
      required: true,
      default: '#'
    }
  },
  data () {
    return {
      currentCustomer: {
        contract: {
          encryptedMsisdn: null
        }
      }
    }
  },
  mixins: [
    transaction('deviceConfig')
  ],
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query deviceConfig {
        currentCustomer {
          contract {
            encryptedMsisdn
          }
        }
      }`, this, 'currentCustomer')
    }
  },
  computed: {
    targetUrl () {
      if (this.currentCustomer.contract.encryptedMsisdn == null) {
        return null
      }
      return this.baseUrl + '&ui=' + this.currentCustomer.contract.encryptedMsisdn
    }
  }
}
</script>
